import { Col, Form, Input } from 'antd';
import type { IField } from '../data';
import styles from '../styles.less';

const { Item } = Form;

const TextArea: React.FC<IField> = (props) => {
    const { name, span = 8, label, placeholder, xs, lg, marginBottom = 0, rows = 4, maxLength, rules, readOnly, t, onChange } = props;

    const grid = {
        xs: xs || span,
        lg: lg || span,
        span: span,
    };

    const styling = {
        style: marginBottom ? { marginBottom } : {},
    };

    return (
        <Col key={name} {...grid}>
            <Item label={t?.(label)} {...styling} name={name} rules={rules}>
                <Input.TextArea readOnly={readOnly} className={styles.fullWidth} rows={rows} onChange={onChange} placeholder={t?.(placeholder)} maxLength={maxLength} />
            </Item>
        </Col>
    );
};

export default TextArea;
